import bilAPI from "./api";

// Self-service profile edit. Sends multipart when a portrait File is present
// (so the ImageField upload works), otherwise a plain JSON PATCH. The response
// is the full `/auth/me/` shape, so callers can drop it straight into setUser.
export const updateMe = ({ body = {}, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      const hasFile = body.portrait_image instanceof File;
      let payload = body;
      let config = { signal };

      if (hasFile) {
        const fd = new FormData();
        Object.entries(body).forEach(([key, value]) => {
          if (value !== undefined && value !== null) fd.append(key, value);
        });
        payload = fd;
        config = { signal, headers: { "Content-Type": "multipart/form-data" } };
      }

      bilAPI
        .patch(`/auth/me/`, payload, config)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

export const changePassword = ({ body, signal } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .put(`/auth/change-password/`, body, { signal })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};
